<template lang="pug">
    button(
        ref="_in",
        type="submit",
        class="_btn",
        :class="{ [tone]: tone, [appearance]: appearance, _busy: busy || dispatching }",
        :style="{ width, height }",
        :id="id",
        :disabled="disabled || busy || dispatching",
        :inert="inert",
        :tabindex="inert ? -1 : tabindex",
        v-on="__on")
        slot &#xfeff;
        span(v-if="busy || dispatching", class="_busyi")
            slot(name="busy")
                ib-progress-dots
</template>

<script>
    import button from './ib-button.vue'

    /**
    * A button that triggers a form's validation and submission handlers
    */
    export default {
        name: 'ib-button-submit',
        mixins: [button],

        props: {
            /**
             * Semantic color class.
             */
            tone: {
                type: String,
                default: 'accent'
            }
        }
    }
</script>

<docs>
    ```jsx
        <div>
            <p>Derivative of `ib-button` that submits the nearest enclosing `ib-form`.</p>
            <ib-button-submit>Submit</ib-button-submit>
        </div>
    ```
</docs>
